module.exports = __webpack_public_path__ + "img/code-compare.c82fad54.svg";